// extracted by mini-css-extract-plugin
export default {"productButton":"ProductButton_productButton__-5CyN","outOfStock":"ProductButton_outOfStock__kYFQj"};